import { environment } from 'apps/gs-2.0/src/environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.fund.server;
  }

  get(path: string, params = {}, headers = {}) {
    return this.http.get(`${this.apiUrl}${path}`, { params, headers });
  }

  put(path: string, body = {}) {
    return this.http.put(`${this.apiUrl}${path}`, body);
  }

  post(path: string, body = {}, params = {}) {
    return this.http.post(`${this.apiUrl}${path}`, body, { params });
  }

  postBlob(path: string, body = {}) {
    return this.http.post(`${this.apiUrl}${path}`, body, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  postWithHeaders(path: string, body = {}, headers = {}, params = {}) {
    return this.http.post(`${this.apiUrl}${path}`, body, { headers, params });
  }

  delete(path: string, body = {}) {
    return this.http.delete(`${this.apiUrl}${path}`, { body: body });
  }
}